// src/Home.js
import React from "react";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
import Cookies from "js-cookie";

const Home = () => {
  const signOut = useSignOut();

  const handleLogout = () => {
    // Remove the cookie and sign out using react-auth-kit
    Cookies.remove("auth_cookie_name");
    signOut();
    window.location.href = "/login"; // Redirect to APISIX login route
  };

  return (
    <div>
      <h1>Welcome to the Home Page</h1>
      <p>This is a protected route.</p>
      <button onClick={handleLogout}>Logout</button>
    </div>
  );
};

export default Home;
